import { ChevronUp } from "lucide-react";
import { ReactNode, useState, useRef, useEffect } from "react";

export const ExpandableText = ({
  children,
  height = 45,
}: {
  children: ReactNode;
  height?: number;
}) => {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [expandable, setExpandable] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      const scrollHeight = contentRef.current.scrollHeight;
      setContentHeight(scrollHeight);
      setExpandable(scrollHeight > height);
    }
  }, [children]);

  return (
    <div>
      <div
        ref={contentRef}
        style={{
          maxHeight: expanded ? `${contentHeight}px` : `${height}px`,
          overflow: "hidden",
          transition: "max-height 0.3s ease-out",
          cursor: expandable && !expanded ? "default" : "auto",
        }}
        onClick={(e) => {
          if (expandable && window.getSelection()?.toString() === "") {
            setExpanded(!expanded);
          }
        }}
      >
        {children}
      </div>
      {expandable && (
        <div
          onClick={() => setExpanded(!expanded)}
          className="d-flex hover text-sm gray fs-11"
        >
          {expanded ? <ChevronUp size={14} /> : "..."}
        </div>
      )}
    </div>
  );
};
